// extracted by mini-css-extract-plugin
module.exports = {"btn":"button-only-icon_btn__igsQw"};